// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import SearchTextField, { SearchTextFieldStyles } from "@store/Library/Widgets/ShipmentHistory/SearchTextField";
import * as React from "react";

export const poNumberStyles: SearchTextFieldStyles = {};
const styles = poNumberStyles;

const ShipmentHistorySearchPoNumber: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            styles={styles}
            parameterField="purchaseOrderNumber"
            label={translate("PO #")}
            inputType="text"
            placeholder=""
            testSelector="shipmentHistory_filterPONumber"
        />
    );
};

const widgetModule: WidgetModule = {
    component: ShipmentHistorySearchPoNumber,
    definition: {
        group: constants.widgetGroup.shipmentHistory,
        displayName: "PO Number",
        allowedContexts: [constants.pageType.shipmentHistory],
    },
};

export default widgetModule;
